const digest = 'c1e426c1f3c2d5729dba28cf6a72171da6def26257f6415ed4c262f4b625e95c';
const css = `._paypal-page-wrapper_m5qj4_1 .MainLayout__logos img.MainLayout__logo:nth-of-type(2){height:25px!important;margin:auto}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'paypal-page-wrapper': '_paypal-page-wrapper_m5qj4_1' };

export { css, digest };